import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatDate } from '@utils/formatters/date.formatter'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const RenewalReminderAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()

  if (!alert.subscription) {
    return null
  }
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.renewalReminder')}</p>
      <p>
        {t('content.renewalReminderDetails', {
          planName: alert.subscription.displayable_plan_name,
          amount: formatPriceInCents(alert.subscription.quote.recurring_charge, {
            showDouble0ForCents: true,
          }),
          date: formatDate(alert.subscription.renew_date),
        })}
      </p>
    </AlertCard>
  )
}

export default RenewalReminderAccountAlert
